import { toRaw, unref } from 'vue'
import { trackDrawSymbolImpl } from './TrackDrawSymbolImpl'

interface TrackDrawItem {
  id: string
  // 其他属性根据实际需求添加
  polyLineLayer?: any
}

export class TrackDrawServiceImpl {
  private _options: any = {}
  private _map: any // 这里需要根据实际的地图对象类型来定义
  private _items: { [key: string]: TrackDrawItem }

  constructor(map: any, options?: any) {
    this._map = map
    this._items = {}
    this._options = Object.assign({}, options)
  }

  addTrackDraw(symbolOptions: any, trackData: any): TrackDrawItem {
    // 这里需要根据实际的trackDrawSymbolImpl函数返回类型来定义
    const trackDrawItem: TrackDrawItem = trackDrawSymbolImpl(
      toRaw(unref(this._map)),
      symbolOptions,
      trackData
    )
    this._items[trackDrawItem.id] = trackDrawItem
    return trackDrawItem
  }

  hasTrackDrawSymbolShow(): boolean {
    for (const key in this._items) {
      if (this._items[key] && this._items[key].polyLineLayer) {
        return true
      }
    }
    return false
  }
}

export const trackDrawServiceImpl = (map: any, options?: any) =>
  new TrackDrawServiceImpl(map, options)
